export default str => {
  const isHTMLRegExp = /<[a-z][\s\S]*>/i
  if (!isHTMLRegExp.test(str)) return str
  const container = document.createElement('div')
  container.innerHTML = str
  return container.textContent || container.innerText
}



// WEBPACK FOOTER //
// ./src/utils/getTextFromHTMLStr.js